import { render, staticRenderFns } from "./ViewBespokeOrder.vue?vue&type=template&id=85849bd0&"
import script from "./ViewBespokeOrder.vue?vue&type=script&lang=js&"
export * from "./ViewBespokeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports